import {
    UPDATE_SUBSCRIBE_TEXT_INPUT,
    UPDATE_SUBSCRIBE_COUNTRY_ACTION,
    UPDATE_SUBSCRIBE_CONSENT_CHECKBOX_INPUT,
    PENDING_SUBSCRIBE_REQUEST,
    FINISHED_SUBSCRIBE_REQUEST,
    UPDATE_SUBSCRIBE_REQUEST,
    TRY_AGAIN_TO_SUBSCRIBE
} from '../actions/SubscribeActions';
import produce from "immer";
import TextInput from "../components/form/TextInput";

const initialState = {
    fields: {
        email: TextInput.getDefaultValues(),
        country: { value: '', touched: false },
        checkbox: { value: false, touched: false },
    },
    isPending: false,
    requested: false,
    requestResult: false
};

export default class SubscribeReducer {
    /**
     * @param {object} state
     * @param {object} action
     */
    static reduce(state = initialState, action) {
        switch (action.type) {
            case UPDATE_SUBSCRIBE_TEXT_INPUT:
            case UPDATE_SUBSCRIBE_COUNTRY_ACTION:
            case UPDATE_SUBSCRIBE_CONSENT_CHECKBOX_INPUT: {
                return produce(state, draftState => {
                    SubscribeReducer.updateInput(draftState, action);
                });
            }
            case PENDING_SUBSCRIBE_REQUEST: {
                return {
                    ...state,
                    isPending: true
                }
            }
            case FINISHED_SUBSCRIBE_REQUEST: {
                return {
                    ...state,
                    isPending: false,
                    requested: true
                }
            }
            case UPDATE_SUBSCRIBE_REQUEST: {
                return {
                    ...state,
                    requestResult: action.status
                }
            }
            case TRY_AGAIN_TO_SUBSCRIBE: {
                return {
                    ...state,
                    requested: false
                }
            }
            default:
                return state;
        }
    }

    /**
     * @param {object} draftState
     * @param {object} action
     */
    static updateInput(draftState, action) {
        const { name, data } = action;
        const { touched, ...updatedData } = data;

        draftState.fields[name] = {
            ...draftState.fields[name],
            ...updatedData,
            touched: touched === true
        };
    }
}



// WEBPACK FOOTER //
// ./reducers/SubscribeReducer.js